<svelte:head>
  <title>User | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->


<div class="block is-size-7"><a href={$url('../../..')}> &lt; Back to users</a></div>

{#if user}
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">{userId}</h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">

      {#if isAdmin}

      <!-- svelte-ignore a11y-missing-attribute -->
      <a class="button is-secondary" on:click={() => {
        $uiState.activeModal = {
          component: EditEmail,
          props: { userId }
        };
      }}>Change email address</a>
      &nbsp;

      <!-- svelte-ignore a11y-missing-attribute -->
      <a class="button is-secondary" on:click={() => {
        $uiState.activeModal = {
          component: ConfirmDeleteUser,
          props: { userId, gotoPath: '/admin/user' }
        };
      }}>Delete</a>
      &nbsp;
      
      <div class="dropdown is-hoverable is-right">
        <div class="dropdown-trigger">
          <button
            class="button"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
          >
            <span>More</span>
            <span class="icon is-small">
              <i class="mdi mdi-chevron-down" aria-hidden="true" />
            </span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a
              on:click={() => {
                $uiState.activeModal = {
                  component: ConfirmVerifyEmail,
                  props: { userId }
                };
              }}
              class="dropdown-item"
            >
              Verify email
            </a>
          </div>
        </div>
      </div>
      {/if}
    </div>
  </nav>

  {#if userAuth && !userAuth.emailVerified }
  <article class="message is-warning">
    <div class="message-body">
      <p class="block">
        The user's email address is not yet verified.
        <!-- svelte-ignore a11y-missing-attribute -->
        <a on:click={() => {
          $uiState.activeModal = {
              component: ConfirmVerifyEmail,
              props: { userId }
            };
        }}>Verify manually</a>
      </p>
    </div>
  </article>
  {/if}



  <hr />
  <h2 class="is-size-4">Contact</h2>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={userId} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">First name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={user.firstName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Last name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={user.lastName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Phone</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={user.phone} />
        </div>
      </div>
    </div>
  </div>

  <hr />
  <h2 class="is-size-4 mb-3">Organisation account</h2>

  {#if user.charity && charity}

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Type</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled value="Charity">
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={charity.name} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <a href="{$url('/admin/charity/' + user.charity)}">View details</a>
        </div>
      </div>
    </div>
  </div>

  {:else if user.company && company}


  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Type</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled value="Business">
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={company.name} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <a href="{$url('/admin/business/' + user.company)}">View details</a>
        </div>
      </div>
    </div>
  </div>

  {/if}

  {#if userAuth}
  <hr />
  <h2 class="is-size-4 mb-3">Sign-in activity</h2>
  <p>  
  Last signed in: {userAuth.metadata.lastSignInTime}
  </p>
  <p>  
  Created: {userAuth.metadata.creationTime}
  </p>
  {/if}


  {#if errorMessage}
    <div class="block">
      <div class="notification is-danger is-light">
        {errorMessage}
      </div>
    </div>
  {/if}
{/if}

<script lang="ts">
  export let id: string;

  import _ from 'lodash';
  import { goto, url } from '@sveltech/routify';
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';
  import ConfirmVerifyEmail from './_components/ConfirmVerifyEmail.svelte';
  import ConfirmDeleteUser from '../../_components/ConfirmDeleteUser.svelte';
  import EditEmail from './_components/EditEmail.svelte';

  let charity: Charity_v2;
  let company: Company_v1;
  let user: User_v1;
  let userId = id;
  let userAuth: any;

  let errorMessage: string;

  $: isAdmin = $appState.user?.isFullAdmin || ($appState.user?.delegatedAdminTag !== undefined && company?.tags?.includes($appState.user.delegatedAdminTag));

  let firebase = window.firebase;

  getUser();
  getUserAuth();

  async function getUser() {
    
    await firebase
      .firestore()
      .collection('users_v1')
      .doc(userId)
      .onSnapshot((doc) => {
        user = doc.data() as User_v1;

        if(user.charity) {
          firebase
          .firestore()
          .collection('charities_v2')
          .doc(user.charity)
          .onSnapshot((doc) => {
            charity = doc.data() as Charity_v2;
          })
        }
        else if(user.company) {
          firebase
          .firestore()
          .collection('companies_v1')
          .doc(user.company)
          .onSnapshot((doc) => {
            company = doc.data() as Company_v1;
          })
        }
      });
  }

  async function getUserAuth() {
    userAuth = await firebase.functions().httpsCallable('api-account-getuserauth')({email: userId}).then((response) => { return response.data; });
    console.log(userAuth);
  }

</script>
